import { makeStyles } from 'tss-react/mui';
import OpenInternalIcon from '@mui/icons-material/ArrowForward';
import OpenExternalIcon from '@mui/icons-material/OpenInNew';
import classNames from 'classnames';
import { Link as GatsbyLink } from 'gatsby';
import React, { forwardRef } from 'react';

const useStyles = makeStyles()((theme) => ({
  root: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    transition: theme.transitions.create(['color'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      color: theme.palette.primary.light,
    },
  },
  icon: {
    marginRight: 3,
  },
}));

export interface LinkProps {
  to: string;
  enableIcon?: boolean;
  className?: string;
  activeClassName?: string;
  children: React.ReactNode;
  role?: string;
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      className,
      activeClassName,
      to,
      children,
      enableIcon = false,
      role = '',
      ...rest
    },
    ref,
  ) => {
    const { classes } = useStyles();

    const internal =
      to && (to.startsWith(process.env.GATSBY_SITE_URL) || !to.includes('.'));

    if (internal) {
      return (
        <GatsbyLink
          className={classNames(className, {
            [classes.root]: role !== 'button',
          })}
          to={to}
          role={role}
          // @ts-ignore
          ref={ref}
        >
          {enableIcon && (
            <OpenInternalIcon fontSize="inherit" className={classes.icon} />
          )}
          {children}
        </GatsbyLink>
      );
    } else {
      return (
        <a
          className={classNames(className, {
            [classes.root]: role !== 'button',
          })}
          rel="nofollow noreferrer noopener"
          target="_blank"
          href={to}
          role={role}
          ref={ref}
        >
          {enableIcon && (
            <OpenExternalIcon fontSize="inherit" className={classes.icon} />
          )}
          {children}
        </a>
      );
    }
  },
);

export default React.memo(Link);
